import type { MinistryTypeKey } from '@/shared/types/ministry';
import { MinistryTypes, type MinistryType } from '@/store/org/types';
import { Select, SelectItem, type SharedSelection } from '@/components/ui';
import { Icon } from '../icon';
import { useMemo } from 'react';

export function MinistryTypeSelect({
  label,
  value = '',
  onChange,
  className,
  placeholder,
  items = MinistryTypes,
}: {
  label?: string;
  value?: '' | MinistryTypeKey;
  onChange: (type: '' | MinistryTypeKey) => void;
  className?: string;
  icons?: boolean;
  placeholder?: string;
  plural?: boolean;
  items?: MinistryType[];
}) {
  const icons = useMemo(
    () =>
      MinistryTypes.reduce(
        (m, v) => {
          m[v.key] = v.icon;

          return m;
        },
        {} as Record<MinistryTypeKey, string>,
      ),
    [],
  );
  const changeHandler = (key: SharedSelection) => {
    if (!key) {
      onChange('');
    } else if (key instanceof Set) {
      const [sel] = key;
      let value = sel as '' | MinistryTypeKey;
      value ??= '';
      onChange(value);
    }
  };

  const startContent = value === '' ? undefined : <Icon icon={icons[value]} />;

  return (
    <Select
      label={label}
      aria-label='Select Type'
      items={items}
      selectedKeys={[value]}
      onSelectionChange={changeHandler}
      className={className}
      startContent={startContent}
      placeholder={placeholder}
    >
      {items.map((item) => (
        <SelectItem
          key={item.key}
          startContent={<Icon icon={item.icon} width={20} />}
        >
          {item.name}
        </SelectItem>
      ))}
    </Select>
  );
}
